<template>
  <div class="fileFolder">
    <div class="file-top clearfix">
      <div class="top-left f-left">
        <uploader v-if="uploadRoot" :options="options" @upload-start="uploadStart" @file-error="fileError" @file-success="fileSuccess" class="uploader-box f-left">
          <uploader-unsupport></uploader-unsupport>
          <uploader-drop>
            <uploader-btn>
              <i class="fa fa-upload"></i>上传文件
            </uploader-btn>
            <!-- <uploader-btn :directory="true"><i class="fa fa-upload"></i>上传文件夹</uploader-btn> -->
          </uploader-drop>
          <uploader-list v-if="uploadSuccess"></uploader-list>
        </uploader>       
        <el-button class="f-left" size="small" v-if="addRoot" @click="newFolder"><i class="fa fa-plus-square"></i>新建文件夹</el-button>
        <el-button-group class="f-left" v-if="buttonIsShow">
          <!-- <el-button size="small" @click="itemDown(selectAll())"><i class="fa fa-download"></i>下载</el-button> -->
          <!-- <el-button size="small" @click="itemReName(selectAll())" :disabled="disable"><i class="fa fa-edit"></i>重命名</el-button> -->
          <el-button size="small" v-if="delRoot" @click="itemDelete(selectAll())"><i class="fa fa-trash-o"></i>删除</el-button>
          <el-button size="small" v-if="moveRoot" @click="itemMove(selectAll())"><i class="fa fa-send"></i>移动到</el-button>
        </el-button-group>
      </div>
      <div class="top-right f-right">
        <el-input placeholder="搜索你的文件" v-model="search.searchName" class="search">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <!-- <span class="button-icon"><i class="fa fa-th-list"></i></span>
        <span class="button-icon" @click="changeList"><i class="fa" :class="changeIcon"></i></span> -->
      </div>
      <!-- <div class="f-right" style="width:30%;">
        <el-radio-group v-model="scope" size="medium">
          <el-radio :label="0" border>个人文件柜</el-radio>
          <el-radio :label="1" border>公共文件柜</el-radio>
        </el-radio-group>
      </div> -->
    </div>
    <div class="file-box">
      <div class="box-title clearfix">
        <div class="f-left">
          <span v-if="leftTopList.length>1" @click="titleClick(leftTopList[leftTopList.length-2].leftTopAbsolute)">返回上一级 |</span>
          <div class="item_title clearfix" v-for="(item, index) in leftTopList" :key="index">
            <span @click="titleClick(item.leftTopAbsolute)">{{item.leftTopList}}</span>
            <i v-if="index<leftTopList.length-1" class="fa fa-angle-double-right"></i>
          </div>
        </div>
        <div class="f-right">已全部加载，共{{fileLength}}个</div>
      </div>
      <el-table
        ref="multipleTable"
        :data="tableData"
        style="width: 100%"

        v-loading="loading"
        @cell-mouse-enter="handlseCellEnter"
        @cell-mouse-leave="handlseCellLeave"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          label="文件名"
          width="600" class="icon-yellow">
          <template slot-scope="scope">
            <div class="clearfix">
              <div class="f-left" v-if="scope.row.type == 1">               
                <i class="fa fa-folder iconFont" style="color:#FFB90F;"></i>
              </div>
              <div class="f-left" v-else>    
                <div v-if="scope.row.suffix == '.rar' | scope.row.suffix == '.zip'">               
                  <i class="fa fa-file-archive-o iconFont" style="color:#7B68EE;"></i>
                </div>
                <div v-else-if="scope.row.suffix == '.jpg' | scope.row.suffix == '.png' | scope.row.suffix == '.jpeg'  | scope.row.suffix == '.gif'">               
                  <i class="fa fa-file-image-o iconFont" style="color: #00B2EE;"></i>
                </div> 
                <div v-else-if="scope.row.suffix == '.txt'">               
                  <i class="fa fa-file-text-o iconFont" style="color: #8DB6CD;"></i>
                </div> 
                <div v-else-if="scope.row.suffix == '.doc' | scope.row.suffix == '.docx'">               
                  <i class="fa fa-file-word-o iconFont" style="color: #4D4D4D;"></i>
                </div> 
                <div v-else-if="scope.row.suffix == '.ppt'">               
                  <i class="fa fa-file-powerpoint-o iconFont" style="color: #3CB371;"></i>
                </div>
                <div v-else-if="scope.row.suffix == '.pdf'">               
                  <i class="fa fa-file-pdf-o iconFont" style="color: #0000FF;"></i>
                </div>
                <div v-else-if="scope.row.suffix == '.xls' || scope.row.suffix == '.xlsx'">               
                  <i class="fa fa-file-excel-o iconFont" style="color: #0000FF;"></i>
                </div>
                <div v-else-if="scope.row.suffix == '.xsd' | scope.row.suffix == '.xml' | scope.row.suffix == '.html'">          
                  <i class="fa fa-file-code-o iconFont" style="color: #0000FF;"></i>
                </div>
                <div v-else-if="scope.row.suffix == '.mp4'">               
                  <i class="fa fa-file-video-o iconFont" style="color: #0000FF;"></i>
                </div>
              </div>
              <div class="file-a f-left">
                <div v-if = "tempFileName === scope.row.tempFileName" class="clearfix zIndex">
                  <input v-model="nameFile" v-focus="true" class="reName f-left" />
                  <div class="reName-icon" @click="reNameCheck(scope.row.originalName)"><i class="fa fa-check"></i></div>
                  <div class="reName-icon" @click="reNameClose()"><i class="fa fa-close"></i></div>
                </div>
                <!-- @click="seeClick(scope.row.fullName, scope.row.fileOrFolder)" -->
                <div v-else @click="seeClick(scope.row.url, scope.row.type)">{{scope.row.originalName}}</div>
              </div>
            </div>
            <div class="cell-more" v-if = "hoverId === scope.row.id">
              <el-tooltip content="下载" placement="bottom" effect="light">
                <!-- @click="itemDown(scope.row.fullName, scope.row.name, scope.row.fileOrFolder) -->
                <i class="fa fa-download" @click="itemDown([scope.row.id], scope.row.originalName, scope.row.type)"></i>
              </el-tooltip>
              <el-tooltip v-if="delRoot" content="删除" placement="bottom" effect="light">
                <i class="fa fa-trash-o" @click="itemDelete([scope.row.id])"></i>
              </el-tooltip>
              <el-tooltip v-if="moveRoot" content="移动文件" placement="bottom" effect="light">
                <i class="fa fa-send" @click="itemMove([scope.row.id])"></i>
              </el-tooltip>   
              <el-tooltip v-if="reRoot" content="重命名" placement="bottom" effect="light">
                <i class="fa fa-edit" @click="itemReName(scope.row)"></i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="大小"
          sortable
          width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 0">{{scope.row.size}}KB</span>
            <span v-else>- -</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="lastModifiedTime"
          sortable
          label="修改日期"
          show-overflow-tooltip>
        </el-table-column>
      </el-table>
    </div>
    <!-- 删除提示 -->
    <el-dialog
      title="确认删除"
      :visible.sync="dialogDelVisible"
      width="30%"
      >
      <span>确认要把所选文件删除吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDelVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="deleteFile" size="small">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 下载提示 -->
    <el-dialog
      title="确认下载"
      :visible.sync="dialogDownVisible"
      width="30%"
      >
      <span>确认要下载所选文件吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDownVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="downloadFile" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 移动到 -->
    <el-dialog
      title="移动到"
      :visible.sync="dialogMoveVisible"
      width="60%"
      >
      <div class="moveFolder-box">
        <div class="folder-title">
            <span v-if="moveTopList.length>1" @click="movetitleClick(moveTopList[moveTopList.length-2].leftTopAbsolute)">返回上一级 |</span>
            <div class="item_title clearfix" v-for="(item, index) in moveTopList" :key="index">
              <span @click="movetitleClick(item.leftTopAbsolute)">{{item.leftTopList}}</span>
              <i v-if="index<moveTopList.length-1" class="fa fa-angle-double-right"></i>
            </div>
        </div>
        <div class="folder-box">
          <!-- <div :class="{changeBg: changBg=='F:\\test\\upload\\1'}" @click="folderClick('1')" class="clearfix">
            <i class="fa fa-folder iconFont f-left" style="color:#FFB90F;"></i>
            <span class="f-left">全部文件</span>
          </div> -->
          <div :class="{changeBg: changBg==item.fullName}" class="clearfix" v-for="(item, index) in foldData" :key="index" @click="folderClick(item.id, item.url)">
            <i class="fa fa-folder iconFont f-left" style="color:#FFB90F;"></i>
            <span class="f-left">{{item.originalName}}</span>
          </div>
          <div v-if="foldData.length<=0" style="text-align:center;font-size:16px;color:#666;">没有文件了</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogMoveVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="makesureMove" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 遮罩层禁止用户点击页面 -->
    <div :class="{onfocus: focusShow}" v-if="focusShow"></div>
  </div>
</template>
<script>
  import Axios from 'axios'
  import {fileListURL, fileUploadURL, fileDeleteURL, fileDownloadURL, fileMkdirURL, fileRenameURL, fileMoveURL} from '@/api/http'
  export default {
    watch: {  
      search: {  
　　　　handler(newValue, oldValue) {  
　　　　 　for(var key in newValue){
            this.filePost[key] = newValue[key]
          }
          this.allFile()　  
　　　　},  
　　　　deep: true  
  　　},
      scope: {  
　　　　handler(newValue, oldValue) {
          this.filePost.scope = newValue;
          this.filePost['path'] = '/';
          this.allFile();
　　　　},  
　　　　deep: true  
  　　}
    }, 
    data () {
      return {
        search: {
          searchName: ''
        },
        loading:true,
        dialogDelVisible: false,
        dialogDownVisible: false,
        dialogMoveVisible: false,
        buttonIsShow: false,
        reNameShow: false,
        oldFileId: 0,
        tempFileName: 0,   // 临时文件名(数字类型) 无规律  用于新建/重命名
        uploadSuccess: true,
        disable: false,
        focusShow: false,
        isNewFile: false,
        addRoot: false,
        reRoot: false,
        moveRoot: false,
        uploadeRoot: false,
        delRoot: false,
        rootButtons: [],
        hoverId: 0,
        fileName: '文件名',
        changBg: 'F:\\test\\upload\\1',
        nameFile: '',
        srcFile: [],
        reName: '',
        oldName: '',
        destFile: '',
        fileLength: '0',
        fileOrFolder: '',
        filePost: {
          scope: 1
        },
        moveFilePost: {

        },
        reFileName: '',
        selectFileName: '',
        selectArr: [],
        leftTopList: [],
        moveTopList: [],
        changeIcon: 'fa-th-large',
        options: {
          target: fileUploadURL,
          chunkSize: 1024*1024*1024,//超过10G的2倍后开始分块上传
          headers: {Authorization: sessionStorage.getItem('token')},
          testChunks: false,
          allowDuplicateUploads: true,
          // query: { userId: '1', scope: '0', savePath: 'F:\\test\\upload\\1' },
		      query: {}
        }, 
        tableData: [],
        foldData: [],
        multipleSelection: [],

        moveIds: [], // 移动文件使用   
        id: 0,   //新增项  在进入文件夹或返回文件夹时获取
        ids: [],
        scope: 1,   // 判断是个人文件还是公共文件
        downloadFileName: '',
        downloadFileType: 0
      }
    },
    // 选择前排多选按钮
    computed: {
      selectAll: function () {
        return function () {
          this.ids = []
          for (let [index, val] of this.multipleSelection.entries()) {
            this.ids.push(val.id)
          }
          return this.ids
        }
      }
    },
    created () {
      this.allFile()
      this.getButtonRoot()
    },
    methods: {
      // 获取可操作的按钮权限
      getButtonRoot () {
        const buttons = JSON.parse(sessionStorage.getItem('button'));
        let rootButton = [];
        if (buttons.length>0) {
          buttons.map(item => {
            if (item.indexOf('公共文件柜')>-1) {
              rootButton.push(item)
            }
          })
        }       
        if (rootButton.length>0) {
          rootButton.map(item => {
            this.rootButtons.push(item.split('-')[1])
          })
        }
        this.rootButtons.map(item=> {
          if (item=='新建文件夹') {
            this.addRoot = true
          } else if (item=='上传文件'){
            this.uploadRoot = true
          } else if (item=='删除'){
            this.delRoot = true
          } else if (item=='移动'){
            this.moveRoot = true
          } else if (item=='重命名'){
            this.reRoot = true
          }
        })
        // console.log(this.rootButtons)
      },
      uploadStart() {
        this.uploadSuccess = true
      },
      // 文件上传成功
      fileSuccess (rootFile, file, message, chunk) { 
        this.allFile()
        var _this = this
        this.$message.success('文件上传成功')
        setTimeout(function(){ _this.uploadSuccess = false; }, 1500);
      },
      // 文件上传失败
      fileError (rootFile, file, message, chunk) {
        this.$message.warning(message)
      },
      // 查询所有的文件
      allFile () {
        this.loading = true
        this.$http.post(fileListURL, this.filePost)
        .then(res => {
          this.loading = false
          if (res.msg) {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          } else {
            this.id = res.currentPid
            this.tableData = res.data
            this.fileLength = res.data.length
            this.leftTopList = res.leftTop
            this.options.query['pid'] = res.currentPid
		      	this.options.query['scope'] = this.scope
          }            
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
      },
      // 新建文件夹
      newFolder() {
        this.isNewFile = true
        this.focusShow = true
        // this.newFileName = '新建文件夹'
        this.tempFileName = 1
        // this.reNameShow = '新建文件夹'
        this.nameFile = '新建文件夹'
        this.tableData.unshift({
          originalName: '新建文件夹',
          tempFileName: 1,
          type: 1
          // lastUpdateTime: '',
          // fullName: '新建文件夹',
          // url
          // child: 0,
          // lastModifiedTime: '全部文件'
        })
        // 新建确认后会刷新  取消时需要再处理
      },
      // 点击文件名查看
      // seeClick (fileName, fileOrFolder) {
      seeClick (url, type) {
        if(type == 0) {
          // 可做文件预览
          return
        } else {
          this.filePost = {}
          this.filePost['path'] = url
          this.filePost['scope'] = this.scope
          this.allFile()
        } 
      },
      // 点击标题查询数据
      titleClick (fullName) {
        this.filePost = {}
        this.filePost['scope'] = this.scope
        this.filePost['path'] = fullName
        this.allFile()
      },
      // 点击移动的标题
      movetitleClick (fullName) {
        this.changeBg = fullName
        this.moveFilePost.path = fullName
        this.allMoveFolder()
      },
      // 多选框
      handleSelectionChange (val) {
        if (val.length) {
          // this.fileName = '已选中' + val.length + '文件/文件夹'
          this.buttonIsShow = true
          if (val.length > 1) {
            this.disable = true
          } else {
            this.disable = false
          }
        } else {
          // this.fileName = '文件名'
          this.buttonIsShow = false
        }
        this.multipleSelection = val
      },
      // 鼠标进入
      handlseCellEnter (row) {
        this.hoverId = row.id
      },
      // 鼠标离开
      handlseCellLeave () {
        this.hoverId = 0
      },
      // 点击下载
      itemDown (ids, name, type) {
        this.downloadFileName = name
	    	this.downloadFileType = type
        this.ids = ids
        this.dialogDownVisible = true
      },
      // 点击删除
      itemDelete (ids) {
        // this.selectArr = []
        // this.selectArr = arr
        this.ids = ids
        this.dialogDelVisible = true
      },
      // 删除文件
      deleteFile () {
        // {urlName: this.selectArr}
        this.$http.post(fileDeleteURL, {ids: this.ids})
        .then(res => {
          if (res.msg) {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          } else {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.dialogDelVisible = false
            this.allFile()
          }            
        })
        .catch(err => {
          console.log(err)
        })
      },
       // 下载文件
      download (data) {
        if (!data) {
            return
        }
        let url = window.URL.createObjectURL(new Blob([data]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        // if (this.downloadFileType == 1) {
		      link.setAttribute('download', this.downloadFileName + '.zip')
        // }else {
        //   link.setAttribute('download', this.downloadFileName)
        // }       
        document.body.appendChild(link)
        link.click()
      },
      // 下载文件
      downloadFile () {       
        Axios({
           method: 'get',
           url: fileDownloadURL + '/' + this.ids[0],
           responseType: 'blob'
        }).then(response => {
            this.dialogDownVisible = false
            this.download(response)
        }).catch((error) => {

        })
      },
      allMoveFolder () {
         var _this = this
         this.$http.post(fileListURL, this.moveFilePost)
          .then(res => {
            if (res.msg) {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            } else {
              _this.foldData = []
              this.moveTopList = res.leftTop
              res.data.map(function (item) {
                if(item.type == 1){
                  _this.foldData.push(item)
                }
              })
            }            
          })
          .catch(err => {
            console.log(err)
          })
      },
      // 点击移动文件
      itemMove (ids) {
        // ids 要移动的目标
        this.selectArr = []
        this.ids = ids
        this.dialogMoveVisible = true
        this.foldData = []
        this.moveTopList = []

        this.moveIds = ids

        this.moveFilePost = {}
        this.moveFilePost['path'] = "/"
        this.moveFilePost['scope'] = this.scope
        // this.destFile = 'F:\\test\\upload\\1'
        this.allMoveFolder()
      },
      // 单击选择文件-移动
      folderClick (id, url) {
        // id: 要移动到的目标地点
        this.changBg = url
        this.destFile = url

        this.moveFilePost = {}
        this.moveFilePost['path'] = url
        this.moveFilePost['scope'] = this.scope
        this.allMoveFolder()
      },
      // 双击进入下一级
      // dbClick (fullName, hasChild) {
      //   // this.moveFilePost.path = fullName
      //   // if (hasChild == 1) {
      //   //   this.allMoveFolder()
      //   // } else{
      //   //   return 
      //   // }
      // },
      // 点击重命名
      // itemReName (oldName, nameFile) {
      itemReName (file) {
        this.nameFile = file.originalName
        file.tempFileName = 2
        this.tempFileName = 2
        this.oldFileId = file.id
        this.focusShow = true
        // this.oldName = oldName
        // this.nameFile = nameFile
        // this.reNameShow = oldName
      },
      // 重命名完成
      reNameCheck (name) {
        //判断是否是新建文件夹
        if (this.isNewFile) {
          this.$http.post(fileMkdirURL, {originalName: this.nameFile, scope: this.scope, pid: this.id})
          .then(res => {
            if (res.msg) {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            } else {
              this.$message({
                message: '创建文件夹成功',
                type: 'success'
              });
              this.focusShow = false
              this.reNameShow = null
              this.dialogDelVisible = false
              this.isNewFile = false
              this.allFile()
            }            
          })
          .catch(err => {
            console.log(err)
          })
        } else {
          this.$http.put(fileRenameURL, {id: this.oldFileId, newFile: this.nameFile})
          .then(res => {
            if (res.msg) {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            } else {
              this.$message({
                message: '重命名成功',
                type: 'success'
              });
              this.dialogDelVisible = false
              this.allFile()
              this.focusShow = false
              this.reNameShow = null
            }            
          })
          .catch(err => {
            console.log(err)
          })           
        }
      },
      // 取消重命名
      reNameClose () {
        // 取消新建
        if (this.isNewFile) {
          this.tableData.splice(this.tableData.findIndex(v => v.tempFileName === this.tempFileName), 1)
        } else {
          var index = this.tableData.findIndex(v => v.tempFileName === this.tempFileName)
          this.tableData[index].tempFileName = -1
          this.tempFileName = 0
          this.focusShow = false
        }
        this.nameFile = ''
        this.reNameShow = null
        this.focusShow = false
        this.isNewFile = false
      },
      // 确定移动文件
      makesureMove () {
        this.$http.post(fileMoveURL,{ids: this.moveIds, scope: this.scope, destFile: this.moveFilePost['path']})
        .then(res => {
          if (res.msg) {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          } else {
            this.$message({
              message: '文件移动成功',
              type: 'success'
            });
            this.dialogMoveVisible = false
            this.allFile()
          }            
        })
        .catch(err => {
          console.log(err)
        })
      }
    },
    directives: {
      focus: {
        inserted: function (el, {value}) {
          if (value) {
            el.focus()
          }
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  .folder-box{
    width:90%;
    margin:0 auto;
    div{
      margin:10px 0;
      cursor: pointer;
      padding:0 10px;
    }
  }
  .iconFont{
    margin-right:10px;
    font-size:26px;
  }
  .onfocus{
    position:absolute;
    left:0;
    top:0;
    width:100%;
    height:100%;
    z-index: 100;
  }
  .zIndex{
    position:absolute;
    z-index: 999;
    left:40px;
    top:0;
    padding:15px 5px;
    width:90%;
    height:50px;
    background: #D1EEEE;
  }
  .fileFolder{
    background:#fff;
    padding:10px;
    .changeBg{
      background:	#E0E0E0;
    }
    .moveFolder-box{
      max-height:400px;
      overflow: auto;
      .folder-title{
        .item_title{
          display: inline-block;
          color:#00B2EE;
          margin-left:3px;
        }
        .item_title:last-child{
          color:#666;
        }
        span{
          cursor: pointer;
          max-width:100px;
          text-overflow:ellipsis; 
          overflow:hidden; 
          white-space: nowrap; 
          float:Left;
          font-size:12px;
          &:hover{
            color:#4682B4;
          }
        }       
        i{
          float:Left;
          font-size:14px;
          line-height: 16px;
          margin:0 3px;
          color: #4682B4;
          line-height: 24px;
        }
      }
    }
    .top-left{
      width:55%;
      i{
        font-size:14px;
        margin-right:10px;
      }
    }
    .top-right{
      width:30%;
      .search{
        width:70%;
      }
      text-align: right;
      .button-icon{
        width:40px;
        border:none;
        text-align: center;
        display: inline-block;
        cursor: pointer;
        font-size:18px;
        outline: none;
        color:#999;
        &:hover{
          color:lightseagreen;
        }
      }
    }
    .file-box{
      .box-title{
        color:rgb(102, 102, 102);
        font-size:12px;
        padding:10px 5px;
        color:#00B2EE;
        .item_title{
          display: inline-block;
          color:#00B2EE;
          margin-left:3px;
        }
        .item_title:last-child{
          color:#666;
        }
        span{
          cursor: pointer;
          display: inline-block;
          max-width:100px;
          text-overflow:ellipsis; 
          overflow:hidden; 
          white-space: nowrap; 
          float:Left;
          &:hover{
            color:#4682B4;
          }
        }
        
        i{
          float:Left;
          font-size:14px;
          line-height: 16px;
          margin:0 3px;
          color: #4682B4;
        }
      }
      .reName{
        width:200px;
        height:20px;
        border:1px solid #ccc;
        line-height: 20px;
        font-size:12px;
        padding:0 5px;
      }
      .file-a{
        cursor: pointer;
        .reName-icon{
          width:22px;
          height:22px;
          text-align: center;
          line-height: 22px;
          border:1px solid #ccc;
          background: #fff;
          font-size:14px;
          float: left;
          color:lightseagreen;
          margin-left: 5px;
        }
        &:hover{
          color:#00B2EE;
        }
      }
      .cell-more{
        position:absolute;
        right:10px;
        top:15px;
        text-align: right;
        .fa{
          font-size:16px;
          margin:0 10px;
          cursor: pointer;
          color:#00B2EE;
        }
      }
    }
    .uploader-drop{
      padding:0;
      border:none;
    }
    .uploader-btn{
      padding:6px 10px;
      margin-right:5px;
      background: #1E90FF;
      color:#fff; 
      border: 1px solid #dcdfe6;
      border-radius: 3px;
      &:hover{
        background: #12AFE3;
      }
    }
    .uploader-list{
      position:fixed;
      bottom:0px;
      right:0px;
      z-index: 9999;
      width:600px;
    }
  }
  .uploader-file[status=success] .uploader-file-remove{
    display: block !important;
  }
</style>




// WEBPACK FOOTER //
// src/pages/fileFolder/index.vue